import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'
import { BlocksContent } from '@strapi/blocks-react-renderer'

export interface GetOurHistoryArgs {
  locale: string
}

export interface GetOurHistoryDto {
  data: Data
  meta: unknown
}

export interface Data {
  id: number
  attributes: GetOurHistoryAttributesDto
}

export interface GetOurHistoryAttributesDto {
  our_history_title: string
  discover_more_button_text: string
  our_history: OurHistoryDto[]
}

export interface OurHistoryDto {
  id: number
  title: string
  text: BlocksContent
  image: MediaObject
}

export interface Text {
  type: string
  children: Children[]
}

export interface Children {
  text: string
  type: string
}

export const getOurHistory = async (
  client: AxiosInstance,
  { locale }: GetOurHistoryArgs,
): Promise<GetOurHistoryAttributesDto> => {
  const path = `/home-page`
  const params = {
    locale,
    fields: ['our_history_title', 'discover_more_button_text'],
    populate: {
      fields: ['our_history'],
      our_history: {
        populate: '*',
      },
    },
  }
  return (await client.get<GetOurHistoryDto>(path, { params })).data.data.attributes
}
